export default function () {
    return {
        action: fn => fn(),
        label: label => label,
        showPriceDuringSearch: computed(() => true),
    }
}
